import styled from 'styled-components';

const NativeAdContainer = styled.div`
  width: 948px;
  max-width: 100vw;
`;

export { NativeAdContainer };
